module.exports = new __parcel__URL__("high-priority.427a170e.svg").toString();